// import { checkIsTouchDevice } from '@amazing-gaming/components/dist/common/utils';

import { CSSObject } from '@mui/material';

import { checkIsTouchDevice } from '../../../common/utils';
import { transitions } from '../../options';

const touchDevice = checkIsTouchDevice();

const root: CSSObject = {
  'cursor': 'pointer',

  'position': 'relative',

  'width': 'auto',
  'height': 'auto',

  'minWidth': 'auto',
  'minHeight': 'auto',
  'maxWidth': 'none',
  'maxHeight': 'none',

  'userSelect': 'none',
  'willChange': 'auto',

  'opacity': 1,

  'outline': !touchDevice ? '0px auto' : 'none !important',

  'borderStyle': 'solid',

  'fontWeight': 600,
  'textTransform': 'uppercase',
  'whiteSpace': 'nowrap',
  // 'lineHeight': 'base',
  'letterSpacing': '.8px',

  'WebkitTapHighlightColor': 'transparent',

  'transition': `${transitions.duration?.shortest || 150}ms ${
    transitions.easing?.easeOut || 'ease-out'
  } !important`,

  '&:focus:not(:focus-visible)': {
    outline: !touchDevice ? '0px auto' : 'none !important'
  },

  '&:focus': {
    boxShadow: 'none',
    outline: !touchDevice ? '0px auto' : 'none !important'
  },

  '&:active': {
    outline: !touchDevice ? '0px auto' : 'none !important'
  }
};

export default root;
